// extracted by css-extract-rspack-plugin
export default {"container":"AssigneeAvatars-module__container__XUhjL","overflowButton":"AssigneeAvatars-module__overflowButton__u44Vw","squareAvatar":"AssigneeAvatars-module__squareAvatar___igij"};